export const ACTION_TYPE = {
  ADD: 0,
  EDIT: 1,
  DELETE: 2,
  RESTORE: 3,
};
